import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

// import { memberViewAction, loadMemberViewStore } from "./Module/actions";
import { dataEmpty, generateObjectDummyId } from "components/CommonLib/CommonLib";
import TableTitleWithButton from "components/TableTitleWithButton/TableTitleWithButton";

import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import ComboBox from "components/LabelInput/ComboBox";
import DatePicker from "components/LabelInput/DatePicker";

import TextField from "components/LabelInput/TextField";
import NormalBtn from "components/NewButton/NormalBtn";

const FamilyCard = forwardRef((props, ref) => {
  const [itemInfoList, setItemInfoList] = useState(props.staffInfoState.family);

  useEffect(() => {
    setItemInfoList(props.staffInfoState.family);
  }, [props.staffInfoState.family]);

  useImperativeHandle(ref, () => ({
    getItemList: () => {
      return itemInfoList;
    },
  }));

  const btnItemPush = () => {
    // const methodId = uuidv4();
    let lenList = itemInfoList.length;
    const baseItemInfo = {
      id: generateObjectDummyId(),
      idx: lenList,
      relation: "",
      name: "",
      birthday: "",
      job: "",
      is_cohabit: false,
    };

    if (itemInfoList.length === 0) {
      setItemInfoList([baseItemInfo]);
    } else {
      setItemInfoList([...itemInfoList, baseItemInfo]);
    }
    props.staffInfoState.family.push(baseItemInfo);
  };
  const btnItemPop = (targetId) => {
    var array = [...itemInfoList]; // make a separate copy of the array
    const index = array.map((item) => item.id).indexOf(targetId);

    if (index !== -1) {
      array.splice(index, 1);
      props.staffInfoState.family.splice(index, 1);
      setItemInfoList(array);
    }
  };
  let itemList = new itemInfoTable(btnItemPop);

  return (
    <div style={{ padding: "0.625rem 1.25rem", border: "1px solid #bbb", marginTop: "1rem" }}>
      <div style={{}}>
        <TableTitleWithButton
          titleLabel={"가족 사항"}
          buttonText={"추가"}
          onClickEvent={btnItemPush}
        />
      </div>
      <div>
        <CustomTable
          columns_head={itemList.columns_head}
          table_title={itemList.table_title}
          rest_call={itemList.get_data_from_rest}
          row_render={itemList.create_table}
          rest_data={itemInfoList}
        />
      </div>
    </div>
  );
});
export default FamilyCard;

class itemInfoTable {
  table_title = "";
  // refundInfoList = [];
  btnPayMethodPop = null;

  constructor(btnPayMethodPop) {
    this.btnPayMethodPop = btnPayMethodPop;
  }

  getAge = (birth) => {
    if (birth !== "") {
      return new Date().getFullYear() - Number(birth.substring(0, 4)) + 1;
    } else {
      return 0;
    }
  };

  create_table = (data, key) => {
    return (
      <CustomRow key={key} style={{ width: "100%" }}>
        <CustomTableContents width="10%">
          <TextField
            justifyContent="center"
            textBoxWidth={"12rem"}
            labelMarginLeft={"0rem"}
            textMarginRight={"0rem"}
            defaultValue={data.name}
            onChangeCallback={(e) => {
              data.name = e;
            }}
          />
        </CustomTableContents>

        <CustomTableContents width="10%">
          <TextField
            justifyContent="center"
            textBoxWidth={"12rem"}
            labelMarginLeft={"0rem"}
            textMarginRight={"0rem"}
            defaultValue={data.relation}
            onChangeCallback={(e) => {
              data.relation = e;
            }}
          />
        </CustomTableContents>

        <CustomTableContents width="10%">
          <DatePicker
            // inputRef={tmTryTimeRef}
            justifyContent="center"
            minWidth={"12rem"}
            defaultValue={data.birthday}
            onChangeCallback={(e) => {
              data.birthday = e;
            }}
          />
        </CustomTableContents>
        {/* <CustomTableContents width="10%">
          <TextField
            justifyContent="center"
            textBoxWidth={"12rem"}
            labelMarginLeft={"0rem"}
            textMarginRight={"0rem"}
            defaultValue={this.getAge(data.birthday)}
            disabled
          />
        </CustomTableContents> */}
        <CustomTableContents width="10%">
          <TextField
            justifyContent="center"
            textBoxWidth={"12rem"}
            labelMarginLeft={"0rem"}
            textMarginRight={"0rem"}
            defaultValue={data.job}
            onChangeCallback={(e) => {
              data.job = e;
            }}
          />
        </CustomTableContents>
        <CustomTableContents width="10%">
          <ComboBox
            justifyContent="center"
            comboItemWidth={"12rem"}
            labelText=""
            data={["동거", "비동거"]}
            defaultValue={data.is_cohabit}
            onChangeCallback={(e) => {
              data.is_cohabit = e.target.value === "동거" ? true : false;
            }}
          />
        </CustomTableContents>
        <CustomTableContents width="5%">
          {/* {data.remove} */}
          {data.is_lock ? (
            <NormalBtn name="삭제" width="4.5rem" onClick={() => this.btnPayMethodPop(data.id)} />
          ) : (
            ""
          )}
        </CustomTableContents>
      </CustomRow>
    );
  };
  columns_head = [
    { title: "이름", field: "select" },
    { title: "관계", field: "pay_method" },
    { title: "생년월일", field: "pay_method" },
    // { title: "나이", field: "card_no" },
    { title: "직업", field: "card_no" },
    { title: "동거여부", field: "remove" },
    { title: "", field: "remove" },
  ];
  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      return [];
    }

    return stateData;
  };
}
